export type AccountAssociationRequest = {
  associationType: LoyaltyCardAssociationTypeRequest;
};

export enum LoyaltyCardAssociationTypeRequest {
  NONE,
  COL,
  CC,
}
